(async () => {
  const { hideElement } = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('announcement-bar', class extends baseComponent.default {
    elements = {
      buttonClose: '[data-dismiss]',
    }

    render() {
      if (this.hasAttribute('dismissible')) {
        this._useDismiss();
      }
    };

    _useDismiss() {
      this.$buttonClose.addEventListener('click', this._closeBar.bind(this), { once: true });

    };

    _closeBar() {
      try {
        window.sessionStorage.setItem('hideAnnouncement', 'true');
      } catch (error) {}
      hideElement(this)
    }
  });
})();